import { createApp } from "vue";
import App from "@/main/App.vue";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "@mdi/font/css/materialdesignicons.css";
import { router } from "@/main/plugins/router.plugin";
import { createI18n } from "vue-i18n";

import locales_en from "@/main/locales/en.json";
import locales_uk from "@/main/locales/uk.json";

const languages = {
  en: locales_en,
  uk: locales_uk,
};

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const vuetify = createVuetify({
  components,
  directives,
});

const i18n = createI18n({
  legacy: false,
  locale: "uk",
  messages: Object.assign(languages),
  fallbackLocale: "en",
});

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(pinia);
app.use(i18n);

app.mount("#app");
